import { render, staticRenderFns } from "./slayer.vue?vue&type=template&id=b15441c0&lang=pug"
import script from "./slayer.vue?vue&type=script&lang=js"
export * from "./slayer.vue?vue&type=script&lang=js"
import style0 from "./slayer.vue?vue&type=style&index=0&id=b15441c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports